import { navigate } from 'astro:transitions/client';
import type { DocSearchSearchResult } from '@repo/doc-search';
import {
  CommandItem,
  Highlighter,
  type HighlighterProps,
  Text,
} from '@repo/ui';
import { useMemo } from 'react';
export type SearchItemProps = {
  result: DocSearchSearchResult;
};

const DEFAULT_HIGHTLIGHT_PROPS: Partial<HighlighterProps> = {
  // highlightTag: 'span',
};

const ProgramResult = ({
  result,
  highlightClassNames,
}: SearchItemProps & {
  highlightClassNames: {
    [key: string]: string;
  };
}) => {
  return (
    <div className="flex w-full flex-col ">
      <Text variant="bold">
        <Highlighter
          {...DEFAULT_HIGHTLIGHT_PROPS}
          highlightClassName={highlightClassNames}
          textToHighlight={result.name}
          searchWords={result.terms}
        />
      </Text>

      <Text variant={'muted'}>
        <Highlighter
          {...DEFAULT_HIGHTLIGHT_PROPS}
          highlightClassName={highlightClassNames}
          textToHighlight={result.overview || ''}
          searchWords={result.terms}
        />
      </Text>
    </div>
  );
};

// const getSearchPrefix = (type: DocSearchSearchResult["type"]) => {

//   const
// }

const SearchPrefix: Record<
  DocSearchSearchResult['type'],
  {
    prefix: string;
    title: string;
  }
> = {
  program: { prefix: '/programs', title: '' },
  'curriculum-types': { prefix: '/services', title: 'Service' },
  organization: { prefix: '/organizations', title: 'Organization' },
};

export const SearchItem = ({ result }: SearchItemProps) => {
  const highlightClassNames = useMemo(() => {
    const fuzzy = result.terms.reduce<{ [key: string]: string }>(
      (acc, term) => {
        acc[term] = 'text-primary-foreground bg-primary  p-0.5';
        return acc;
      },
      {}
    );
    const exact = result.queryTerms.reduce<{ [key: string]: string }>(
      (acc, term) => {
        acc[term] = 'text-primary-foreground bg-primary  p-0.5';
        return acc;
      },
      {}
    );
    return { ...fuzzy, ...exact };
  }, [result.terms, result.queryTerms]);

  const type = SearchPrefix[result.type];

  const href = `${type.prefix}/${result.slug}`;
  return (
    <CommandItem
      key={result.id}
      className="flex-col items-start gap-0 rounded-none border-b p-2"
      onSelect={() => {
        navigate(href);
      }}
    >
      {type.title && (
        <Text variant="muted" size={'sm'}>
          {type.title}
        </Text>
      )}

      {result.type === 'program' ? (
        <ProgramResult
          highlightClassNames={highlightClassNames}
          result={result}
        />
      ) : (
        <div className="flex ">
          <Text>
            <Highlighter
              {...DEFAULT_HIGHTLIGHT_PROPS}
              highlightClassName={highlightClassNames}
              textToHighlight={result.name}
              searchWords={result.terms}
            />
          </Text>
        </div>
      )}
    </CommandItem>
  );
};
